/**
 * useCommandPalette — open-state + global Cmd+K / Ctrl+K listener.
 */

import { useEffect, useState } from 'react';

export function useCommandPalette(): {
  open: boolean;
  setOpen: (next: boolean) => void;
} {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return { open, setOpen };
}
